import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import HomePage from './pages/HomePage';
import EvidenceManager from './pages/EvidenceManager';
import UseCases from './pages/UseCases';
import Verification from './pages/Verification';
import Enterprise from './pages/Enterprise';
import Login from './pages/Login';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App min-h-screen flex flex-col">
          <Header />

          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/evidence" element={<EvidenceManager />} />
              <Route path="/evidence-manager" element={<EvidenceManager />} />
              <Route path="/use-cases" element={<UseCases />} />
              <Route path="/verify" element={<Verification />} />
              <Route path="/verify/:code" element={<Verification />} />
              <Route path="/enterprise" element={<Enterprise />} />
            </Routes>
          </main>

          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
